import { Types } from "../actions/BackdropActions";

const initialState = {
    isBackdropOpen: true,
};

export const BackdropReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_BACKDROP:
            return {
                ...state,
                isBackdropOpen: false,
            };
        case Types.RESET_BACKDROP:
            return {
                ...state,
                isBackdropOpen: true,
            };

        default:
            return state;
    }
};
